import React from 'react';
import SideImage from './SideImage';
import ScrollArrow from './ScrollArrow';

const FullPageSection = ({ id, className, leftImage, rightImage, leftAlt, rightAlt, children, dataScrollSection }) => {
  return (
    <section id={id} className={`fullpage-section ${className}`} data-scroll-section={dataScrollSection ? '' : undefined}>
      <SideImage src={leftImage} alt={leftAlt} side="left" delay={0.2} />
      <div className="fullpage-content">
        {children}
      </div>
      <SideImage src={rightImage} alt={rightAlt} side="right" delay={0.4} />
      <ScrollArrow sectionId={id} />

    </section>

  );
};

export default FullPageSection;

